<!--  -->
<template>
  <div class="page-component_scroll">
    <el-backtop target=".page-component_scroll">
      <div class="box">
          <img src="../../static/backTop.png" alt="">
      </div>
    </el-backtop>
    <slot></slot>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  components: {},
  methods: {},
};
</script>

<style lang="scss" scoped>
.page-component_scroll {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  overflow-x: hidden;
}
.el-backtop {
  border-radius: 5px !important;
  width: 38px;
  height: 42px;
  background: #fdd000;
  border-radius: 5px;
  align-items: flex-start !important;
  padding-top: 10px;
  box-sizing: border-box;
}

.box {
    img{
        width: 18px;
        height: 25px;  
    }
}
</style>
